import { Button } from '../../shared/ui/button';
import { ErrorState, LoadingState } from '../../shared/ui/states';
import { useSession, type ISession } from '../../entities/session';
import { AccountProfile, useAccountProfile } from '../../features/account-profile';
import { AccountDisplay, useAccountPreferences } from '../../features/account-preferences';
import { SettingsShell } from './settings-shell';

const QUESTION = 'Who you are here, and how hookpipe looks for you.';

const AccountScreen = ({ session }: { session: ISession }) => {
  const profile = useAccountProfile(session.user);
  const account = useAccountPreferences(session.preferences);
  const dirty = profile.dirty || account.dirty;
  const saving = profile.save.isPending || account.save.isPending;

  const save = async () => {
    if (profile.dirty) await profile.save.mutateAsync();
    if (account.dirty) await account.save.mutateAsync();
  };

  return (
    <SettingsShell
      active="/settings/account"
      question={QUESTION}
      actions={
        <Button
          size="sm"
          disabled={!dirty || !profile.nameOk}
          waiting={saving}
          waitingLabel="Saving"
          onClick={() => void save().catch(() => undefined)}
        >
          Save changes
        </Button>
      }
    >
      <AccountProfile user={session.user} profile={profile} />
      <AccountDisplay account={account} />
    </SettingsShell>
  );
};

export const AccountPage = () => {
  const session = useSession();

  if (session.data) return <AccountScreen session={session.data} />;

  return (
    <SettingsShell active="/settings/account" question={QUESTION}>
      {session.isError ? (
        <ErrorState error={session.error} onRetry={() => void session.refetch()} />
      ) : (
        <LoadingState rows={6} />
      )}
    </SettingsShell>
  );
};
